import {
  GET_PROFILE,
  UPDATE_PROFILE,
  PROFILE_ERROR,
  CLEAR_PROFILE,
  LOADING_PROFILE,
  GET_PROFILES,
} from "../actions/types";

const initialState = {
  profile: null,
  profiles: [],
  repos: [],
  loading: true,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    // UPDATE_PROFILE action will trigger two changes to state
    // - Will update profile/user state (in profile.js, here)
    // - Will update auth/user (in auth.js)*
    // * This is required given navbar functionality is governed by auth state and if we change navbar funvtionality (advanced/basic), auth state needs to change
    case UPDATE_PROFILE:
    case GET_PROFILE:
      return {
        ...state,
        profile: payload,
        loading: false,
      };
    case GET_PROFILES:
      return {
        ...state,
        profiles: payload,
        loading: false,
      };
    case PROFILE_ERROR:
      return {
        ...state,
        profile: null,
        profiles: [],
        error: payload,
        loading: false,
      };
    case CLEAR_PROFILE:
      return {
        ...state,
        profile: null,
        repos: [],
        loading: false,
      };
    case LOADING_PROFILE:
      return {
        ...state,
        profiles: [],
        profile: null,
        loading: true,
      };
    default:
      return state;
  }
}
